import React, { PropTypes, Component } from 'react'
import cx from 'classnames'

import './UserProfile.scss'
import UserProfileNavBar from './components/UserProfileNavBar'
import ProfileSidebar from './components/ProfileSidebar'

class UserProfile extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isSidebarExpanded: false,
      navbarTitle: ''
    }

    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.updateTitle = this.updateTitle.bind(this)
  }

  toggleSidebar () {
    this.setState({isSidebarExpanded: !this.state.isSidebarExpanded})
  }

  updateTitle (newTitle) {
    this.setState({navbarTitle: newTitle})
  }

  render () {
    const {
      children,
      userId
    } = this.props

    const {
      isSidebarExpanded,
      navbarTitle
    } = this.state

    const child = React.cloneElement(children, {updateTitle: this.updateTitle})

    const backdropClassName = cx(
      'UserProfile-backdrop',
      {
        'UserProfile-backdrop--expanded': isSidebarExpanded
      }
    )

    return (
      <div className='UserProfile navbar-screen'>
        <UserProfileNavBar
          title={navbarTitle}
          onToggleButtonClick={this.toggleSidebar}
          sidebarExpanded={isSidebarExpanded}
          />
        <div className='UserProfile-content'>
          <div className='UserProfile-sidebarWrapper'>
            <ProfileSidebar isOpen={isSidebarExpanded} userId={userId} />
            {child}
            <div className={backdropClassName} onClick={this.toggleSidebar} />
          </div>
        </div>
      </div>
    )
  }
}

UserProfile.displayName = 'UserProfile'
UserProfile.propTypes = {
  userId: PropTypes.string.isRequired
}
UserProfile.defaultProps = {}

export default UserProfile



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/UserProfile.js